import { Injectable } from '@angular/core';
import { DevMyTitleService } from './dev-my-title.service';
import { Observable, map } from 'rxjs';
import { AclInterface } from 'src/app/onelog/interface/AclInterface';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class AclService {
  isAccessAllowed: boolean = false;

  constructor(
    private devMyTitleService: DevMyTitleService,
    private router: Router
  ) {}

  checkAccess(currentRoute: string): Observable<boolean> {
    return this.devMyTitleService
      .postRequest({ route: currentRoute }, '', '/get_access')
      .pipe(
        map((data: any) => {
          if (data.data.isAllowed == true) {
            return true;
          } else {
            alert('Access Denied'); //TODO Nice Alert
            this.router.navigate(['/list-reports']);
            return false;
          }
        })
      );
  }
}
